<template>
  <div class="ipo-history-wrap">
    <div class="ipo-history-scroll" ref="table">
      <table class="ipo-history-table">
        <thead>
          <tr>
            <th class="d-none d-md-table-cell">#</th>
            <th>{{ $t('ipo.date') }}</th>
            <th :class="mobileVisible(1)">{{ $t('ipo.quantity_2') }}</th>
            <th :class="mobileVisible(1)">{{ $t('ipo.price') }}</th>
            <th :class="mobileVisible(2)">{{ $t('ipo.commission_1') }}</th>
            <th :class="mobileVisible(2)">{{ $t('ipo.total') }}</th>
            <th :class="mobileVisible(3)">{{ $t('ipo.status_1') }}</th>
            <th
              v-if="String(selectedIpo.sell_type) === '3' || String(selectedIpo.sell_type) === '4'"
              :class="mobileVisible(3)"
            >{{ $t('ipo.interest') }}</th>
            <th v-if="String(selectedIpo.sell_type) === '3'" :class="mobileVisible(4)">{{ $t('ipo.type') }}</th>
            <th v-if="selectedIpo.type == 3" :class="mobileVisible(4)">{{ $t('ipo.mse_response') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(order, idx) in orderList"
            :key="order.id"
            :class="rowClass(order.state)"
          >
            <td class="d-none d-md-table-cell">{{ idx + 1 }}.</td>
            <td>{{ fmtDate(order.created_at) }}</td>
            <td :class="mobileVisible(1)">{{ fmtNum(order.size) }} {{ $t('ipo.qty') }}</td>
            <td :class="mobileVisible(1)">{{ fmtMoney(order.rate) }}</td>
            <td :class="mobileVisible(2)">{{ fmtMoney(order.fee_amount) || '—' }}</td>
            <td :class="mobileVisible(2)">{{ fmtMoney(order.amount) || '—' }}</td>
            <td :class="mobileVisible(3)">{{ stateName(order.state) }}</td>
            <td
              v-if="String(selectedIpo.sell_type) === '3' || String(selectedIpo.sell_type) === '4'"
              :class="mobileVisible(3)"
            >{{ order.interest ? order.interest + '%' : '—' }}</td>
            <td v-if="String(selectedIpo.sell_type) === '3'" :class="mobileVisible(4)">
              {{ order.type == 1 ? $t('ipo.bond_type_1') : $t('ipo.bond_type_2') }}
            </td>
            <td v-if="selectedIpo.type == 3" :class="mobileVisible(4)">{{ order.mse_message || '—' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Mobile swipe dots -->
    <div class="ipo-swipe-dots d-md-none">
      <span
        v-for="i in 4" :key="i"
        class="ipo-swipe-dot"
        :class="{ 'ipo-swipe-dot--active': activePage === i }"
        @click="activePage = i"
      ></span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

const ORDER_STATES = {
  1000: 'Хүлээгдэж байна',
  2000: 'Дансны үлдэгдэл хүрэлцэхгүй',
  3000: 'Илгээгдсэн',
  4000: 'Биелсэн',
  5000: 'Цуцлагдсан',
}

export default {
  name: 'IpoOrderHistory',
  data() {
    return { activePage: 1 }
  },
  computed: {
    ...mapGetters('ipoOrder', ['orderList', 'selectedIpo']),
  },
  mounted() {
    const el = this.$refs.table
    if (!el) return
    let startX = 0
    el.addEventListener('touchstart', (e) => { startX = e.changedTouches[0].pageX }, { passive: true })
    el.addEventListener('touchend', (e) => {
      const dist = e.changedTouches[0].pageX - startX
      if (dist > 80 && this.activePage > 1) this.activePage--
      else if (dist < -80 && this.activePage < 4) this.activePage++
    }, { passive: true })
  },
  methods: {
    mobileVisible(page) {
      return this.activePage === page ? 'table-cell' : 'd-none d-md-table-cell'
    },
    stateName(state) { return ORDER_STATES[state] || state },
    fmtDate(ts) { return moment(ts).format('YYYY-MM-DD HH:mm') },
    fmtNum(v) { return new Intl.NumberFormat().format(v ?? 0) },
    fmtMoney(v) {
      const code = this.selectedIpo?.currency_code
      if (!code || code === 'MNT') return '₮ ' + new Intl.NumberFormat().format(v ?? 0)
      return new Intl.NumberFormat('mn-MN', { style: 'currency', currency: code }).format(v ?? 0)
    },
    rowClass(state) {
      if (state === 1000) return 'ipo-row-pending'
      if (state === 3000 || state === 4000) return 'ipo-row-done'
      if (state === 2000 || state === 5000) return 'ipo-row-cancel'
      return ''
    },
  },
}
</script>
